import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: radial-gradient(circle at 70% 50%, #1F5ED9 0%, #020052 50%);


  @media (max-width: 1365px) {
    background: radial-gradient(circle at center, #1F5ED9 0%, #020052 50%);
    flex-direction: column;
    height: auto;
  }
`;

export const EndedContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: radial-gradient(circle at center, #1F5ED9 0%, #020052 50%);

`;

export const LeftColumn = styled.div`
  margin-right: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  

  @media (max-width: 1365px) {
    margin-right: 0;
    padding-top: 16px;
  }
`;

export const Image = styled.div`
  background: url("/assets/logo-main-1920px.svg") center/cover no-repeat;
  height: 259px;
  width: 407px;

  @media (max-width: 1919px) {
    background: url("/assets/logo-main-1366px.svg") center/cover no-repeat;
    height: 182px;
    width: 287px;
  }

  @media (max-width: 1023px) {
    background: url("/assets/logo-main-mobile.svg") center/cover no-repeat;
    height: 130px;
    width: 203px;
  }
`;

export const Text = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #ffffff;
  max-width: 410px;
  margin-top: 35px;
  margin-bottom: 35px;

  strong {
    font-weight: 700;
    color: #ffffff;
  }

  a {
    color: #FF8863;
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-width: 719px) {
    font-size: 16px;
    line-height: 22px;
    max-width: 344px;
  }
`;

export const Button = styled.button`
  background: #77FF47;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 30px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  color: #051A07;

  @media (max-width: 719px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const RightColumn = styled.div`
  @media (max-width: 1365px) {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 40px 0 60px;
  }

  iframe {
    border: 3px solid #265bf1;
    border-radius: 16px;
    width: 1020px;
    height: 602px;

    @media (max-width: 1919px) {
      width: 700px;
      height: 413px;
    }

    @media (max-width: 1365px) {
      width: 1008px;
      height: 595px;
    }

    @media (max-width: 1023px) {
      width: 704px;
      height: 415px;
    }

    @media (max-width: 719px) {
      width: 364px;
      height: 215px;
    }
  }
`;
